import { useDispatch, useSelector } from 'react-redux';
import { RootReducer } from 'redux/reducers';
import { toggleDesignSystemFilterCategory, clearDesignSystemFilters } from 'redux/mode/actions';
import { TokenCategory, ComponentCategory } from 'designSystem/types';
import * as S from './styles';

interface FilterPillsProps {
	section: 'theme' | 'components';
	categories: Array<{
		value: TokenCategory | ComponentCategory;
		label: string;
		count: number;
	}>;
	sticky?: boolean;
	activeSectionId?: string | null;
}

const FilterPills = ({ section, categories, sticky, activeSectionId }: FilterPillsProps) => {
	const dispatch = useDispatch();
	const selectedCategories = useSelector(
		(r: RootReducer) => r.mode.designSystemFilters[section].selectedCategories
	);

	const onToggle = (category: TokenCategory | ComponentCategory) => {
		dispatch(toggleDesignSystemFilterCategory({ section, category }));
	};

	const onClearAll = () => {
		dispatch(clearDesignSystemFilters(section));
	};

	if (categories.length === 0) {
		return null;
	}

	const hasSelectedFilters = selectedCategories.length > 0;

	return (
		<S.Container $sticky={sticky}>
			{categories.map((category) => {
				const isSelected = (selectedCategories as any[]).includes(category.value);
				const isScrollActive =
					!hasSelectedFilters && activeSectionId === category.value;
				return (
					<S.Pill
						key={category.value}
						$selected={isSelected}
						$scrollActive={isScrollActive}
						onClick={() => onToggle(category.value)}
					>
						{category.label}
						{category.count !== undefined && <S.Count>({category.count})</S.Count>}
					</S.Pill>
				);
			})}
			{hasSelectedFilters && <S.ClearButton onClick={onClearAll}>Clear</S.ClearButton>}
		</S.Container>
	);
};

export default FilterPills;
